import { render, staticRenderFns } from "./FbUserServicesTab.vue?vue&type=template&id=8923a450"
import script from "./FbUserServicesTab.vue?vue&type=script&lang=ts"
export * from "./FbUserServicesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports